module.exports = __webpack_public_path__ + "48d193f573457b62e9c9917bb0b61e57.ttf";